import React from 'react'
import "../SideBar/SideBar.css"
import DynamicSVG from '../DynamicSVG/DynamicSVG'
import { NavLink, NavLinkProps } from 'react-router-dom'
export default function SideBar() {
  function ComputeActiveClass(LinkState:{isActive:boolean,isPending:boolean}) {
   
    const className = LinkState?.isActive ? "Active-Link" : "" 
    return className
  }
  function ToggleCheckbox() {
    if(screen.orientation.type.includes("portrait")){
      const checkbox = document.getElementById("Sidebar-Checkbox") as HTMLInputElement
      checkbox.checked = !checkbox.checked
    }
    
  }
  return (
    <>

      <nav className='Sidebar-Container'>
        <input type="checkbox" id='Sidebar-Checkbox' />
        <label id='Sidebar-Btn' htmlFor='Sidebar-Checkbox'>
            <DynamicSVG className="Sidebar-Btn-Svg" SvgName="Menu-Icon"/>
        </label>
        <hr />
        
        <ul className='Sidebar-List'>
          <li>
            <NavLink onClick={ToggleCheckbox} to="/todos" className={ComputeActiveClass}>
              <DynamicSVG className="Sidebar-List-Icon" SvgName="Clipboard-Icon" />
              <span>Todos</span>
            </NavLink>
          </li>
          <li>
            <NavLink onClick={ToggleCheckbox} to="/schedule-todos" className={ComputeActiveClass}>
              <DynamicSVG className="Sidebar-List-Icon" SvgName="Calender-Icon" />
              <span>Schedule Todos</span>
            </NavLink>
          </li>
          {/* <li>
            <NavLink onClick={ToggleCheckbox} to="/projects" className={ComputeActiveClass}>
              <DynamicSVG className="Sidebar-List-Icon" SvgName="Grid-Icon" />
              <span>Projects</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink onClick={ToggleCheckbox} to="/notes" className={ComputeActiveClass}>
              <DynamicSVG className="Sidebar-List-Icon" SvgName="Document-Icon" />
              <span>Notes</span>
            </NavLink>
          </li>
          
        </ul>

        <ul className='Sidebar-List'>
          <li id='User-Profile'>
            <NavLink onClick={ToggleCheckbox} to="/" className={ComputeActiveClass}>
              <DynamicSVG className="Sidebar-List-Icon" SvgName="Profile-Icon" />
              <span>Dashboard</span>
            </NavLink>
          </li>
        </ul>
        <h5 className='Sidebar-Credit'>Created by Zenkin-Tech at <a target="_blank" href='https://zenkin.hashnode.dev/'>Hashnode</a></h5>
      </nav>


    </>
  )
}
